<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title code">VOUCHER CODE</td>
          <td class="listview__title type">TYPE</td>
          <td class="listview__title amount">FIX AMOUNT</td>
          <td class="listview__title redeemed">REDEEMED</td>
          <td class="listview__title active">ACTIVE</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" class="content">
          <td class="code">
            <span>
              <b>{{item.code}}</b>
            </span>
          </td>
          <td class="type">
            <span>
              {{item.type}}
            </span>
          </td>
          <td class="amount">
            <span>
              {{item.amount | formatMoney}}
            </span>
          </td>
          <td class="redeemed">
            <span>
              {{item.redeemed}}
            </span>
          </td>
          <td class="active">
            <adx-toggle @statusChangedMobile="changeStatus(item)" :value="item.active" :itemID="item.id"/>
          </td>
          <td class="edit">
            <span>
              <button class="btn-regular secondary" @click="gotoEdit(item.id)">Edit Voucher</button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="listview__showmore">
      <slot name="infiniteLoading"/>
    </div>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import Toggle from '@/components/Toggle'
import EmptySelection from '@/components/NotFound/Selection'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-vouchers-list',
  components: {
    'adx-toggle': Toggle,
    'adx-empty-selection': EmptySelection,
  },
  props: {
    items: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      loading: false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    changeStatus(item) {
      let data = {
        'is_active': !item.active
      };
      (async () => {
        const response = await api.patch(apiV2.adminVoucherDetail(item.id), data, { needToken: true })
        if (response.status == 200) {
          this.items.map(value => {
            if (value.id == item.id) value.active = !item.active
          })
          // this.$notify({
          //   group: 'saved',
          //   title: 'Status has changed',
          //   text: item.name + ' status has been changed',
          //   type: 'success'
          // });
        } else {
          // this.$notify({
          //   group: 'saved',
          //   title: 'Error',
          //   text: 'sorry something went wrong!',
          //   type: 'warn'
          // });
        }
      })();
    },
    gotoEdit(itemID) {
      this.$router.push({name: 'addmorevoucher', query: { id: itemID }})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>  